import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function UWCourseSearch() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">UW Course Search Web App</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              <Box my={1}>
                • Developed web application on desktop, and designed user
                interface with Adobe Xd.
              </Box>
              <Box my={1}>
                • Developed frontend using React and Boostrap that consumes data
                from a mock backend API call to load real course data from
                UW-Madison.
              </Box>
              <Box my={1}>
                • Implemented features that allow users to search and filter
                courses the users want, give users recommendation based on a
                course history of the user, let user to generate schedules based
                on the courses in the course cart, and let user to manage
                courses with a course cart system.
              </Box>
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              JavaScript (ES6), HTML5, CSS3, SCSS, React, React Router,
              React-Boostrap, Boostrap, Adobe Xd, Google Cloud Platform,
              WebStrom, VS Code
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default UWCourseSearch;
